// extracted by mini-css-extract-plugin
export var container = "my-shopping-lists-module--container--5597e";
export var header = "my-shopping-lists-module--header--695fc";
export var headerAddButton = "my-shopping-lists-module--header-add-button--93fb0";
export var list = "my-shopping-lists-module--list--01f9e";
export var loader = "my-shopping-lists-module--loader--5ad9b";
export var loading = "my-shopping-lists-module--loading--5cf1b";
export var noListAddButton = "my-shopping-lists-module--no-list-add-button--3b51a";
export var noListBox = "my-shopping-lists-module--no-list-box--333df";
export var noListComment = "my-shopping-lists-module--no-list-comment--0cf38";
export var separator = "my-shopping-lists-module--separator--d3078";
export var title = "my-shopping-lists-module--title--b2bf6";